import React, { Component } from "react";
import { Row, Col, Container, Modal } from "react-bootstrap";
import { graphql } from "react-apollo";
import gql from "graphql-tag";
import * as Cookies from "es-cookie";
import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";
import { withApollo } from "react-apollo";
import "./_studentPermission.scss";


const SEND_EVENT_NOTIFICATION = gql`
mutation($params: SendEventNotifications) {
    sendEventNotifications(params: $params)
}`;

class PermissionModal extends Component {
    constructor() {
        super();
        this.state = {
            loadingSpinner: 0,
            sent: false,
            submitError: "",
        };
    }

    handleHolidaysEvent = async () => {
        const list = this.props.stateData.sendStudentsNotificationList;
        if (!list || list.length === 0) {
            this.setState({ submitError: "No students selected for notification." });
            return;
        }

        const params = {
            template_name: this.props.stateData.template_name.toString(),
            institute_id: parseInt(Cookies.get("institutionid")),
            branch_id: list[0].branch_id.toString(),
            request_title: list[0].request_title.toString(),
            parent_mobile: list.map(i => i.parent_mobile).toString(),
            from_datetime: list[0].from_datetime.toString(),
            to_datetime: list[0].to_datetime.toString(),
        };

        this.setState({ loadingSpinner: 1, submitError: "" });

        this.sendEventNotifications(params).catch(error => {
            this.setState({
                submitError: error.graphQLErrors.map(x => x.message).join(", "),
                loadingSpinner: 0
            });
        });
    };

    sendEventNotifications = async (params) => {
        await this.props.sendEventNotifications({
            variables: { params },
            update: (store, { data }) => {
                if (data.sendEventNotifications) {
                    this.setState({ loadingSpinner: 0, sent: true });
                    setTimeout(() => {
                        this.setState({ sent: false, submitError: "" });
                        this.props.onHide();
                    }, 2000);
                }
            }
        });
    };

    render() {
        const list = this.props.stateData.sendStudentsNotificationList || [];

        return (
            <Modal {...this.props} size="lg" aria-labelledby="perm-notify-modal">
                <Modal.Header closeButton className="perm-modal-header-neutral" style={{ borderBottom: "none" }}>
                    <Modal.Title className="modal-title">
                        <i className="fas fa-bell mr-2" />Send Event Notification
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body style={{ background: "#F8FAFC", padding: "28px 28px 20px" }}>
                    {/* ── Info + action bar ── */}
                    <div style={{ background: "#fff", borderRadius: 12, padding: "18px 20px", marginBottom: 18, boxShadow: "0 1px 4px rgba(0,0,0,0.06)" }}>
                        <Row className="align-items-center">
                            <Col sm={8}>
                                <div className="perm-alert perm-alert-info" style={{ marginTop: 0 }}>
                                    <i className="fas fa-info-circle" />
                                    Sending holiday notification to parents of&nbsp;
                                    <strong>{list.length} student{list.length !== 1 ? "s" : ""}</strong>.
                                </div>
                            </Col>
                            <Col sm={4} className="text-right">
                                {this.state.sent ? (
                                    <div className="perm-alert perm-alert-success" style={{ marginTop: 0, justifyContent: "center" }}>
                                        <i className="fas fa-check-circle" />Sent!
                                    </div>
                                ) : (
                                    <button
                                        className="btn-perm-notify"
                                        onClick={this.handleHolidaysEvent}
                                        disabled={this.state.loadingSpinner === 1}
                                        style={{ width: "100%", justifyContent: "center" }}
                                    >
                                        {this.state.loadingSpinner === 1
                                            ? <span className="spinner-border spinner-border-sm" />
                                            : <i className="fas fa-paper-plane" />
                                        }
                                        Send Notification
                                    </button>
                                )}
                            </Col>
                        </Row>

                        {this.state.submitError && (
                            <div className="perm-alert perm-alert-error mt-2">
                                <i className="fas fa-exclamation-circle" />{this.state.submitError}
                            </div>
                        )}
                    </div>

                    {/* ── Student list ── */}
                    <div style={{ background: "#fff", borderRadius: 12, overflow: "hidden", boxShadow: "0 1px 4px rgba(0,0,0,0.06)" }}>
                        <div style={{ padding: "14px 20px 10px", borderBottom: "1px solid #E2E8F0" }}>
                            <p className="perm-section-heading mb-0"><i className="fas fa-list mr-1" />Student List</p>
                        </div>
                        <div className="table-responsive">
                            <table className="perm-modal-table table table-bordered mb-0">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Roll No</th>
                                        <th>Student Name</th>
                                        <th>Parent Name</th>
                                        <th>Parent Mobile</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {list.length > 0 ? list.map((item, idx) => (
                                        <tr key={idx}>
                                            <td>{idx + 1}</td>
                                            <td>
                                                <span style={{ background: "#EEF2FF", color: "#4F46E5", borderRadius: 6, padding: "2px 10px", fontWeight: 700 }}>
                                                    {item?.roll_no || "--"}
                                                </span>
                                            </td>
                                            <td style={{ textAlign: "left", fontWeight: 600 }}>{item?.student_name || "--"}</td>
                                            <td style={{ textAlign: "left" }}>{item?.parent_name || "--"}</td>
                                            <td>{item?.parent_mobile || "--"}</td>
                                        </tr>
                                    )) : (
                                        <tr>
                                            <td colSpan={5}>
                                                <div className="perm-empty-state">
                                                    <div className="perm-empty-icon"><i className="fas fa-inbox" /></div>
                                                    <p>No students in this group.</p>
                                                </div>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        );
    }
}

export default withRouter(withApollo(compose(
    graphql(SEND_EVENT_NOTIFICATION, { name: "sendEventNotifications" })
)(PermissionModal)));
